import cn from 'classnames';
import type { ITimeZone } from '@dealroadshow/uikit-date-time';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import { formatDateOrTime } from '@/creditflowresearch/ui/components/ActiveCalendar/helpers/dates';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';
import { IColumn } from '@creditflowresearch/uilib/Table/DataTable/interfaces/Column';
import ArticleTypesCell from '@/creditflowresearch/ui/components/creditFlow/articles/common/ArticleTypesCell';
import MarketCell from '@/creditflowresearch/ui/components/creditFlow/articles/common/MarketCell';
import HeadlineCell from '@/creditflowresearch/ui/components/creditFlow/articles/common/HeadlineCell';
import SectorIndustryCell
  from '@/creditflowresearch/ui/components/creditFlow/articles/common/SectorIndustryCell/SectorIndustryCell';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';
import textStyles from '@creditflowresearch/uilib/styles/helpers/text.module.scss';
import styles from './articles.module.scss';

const getEmergingMarketColumns = (timeZone: ITimeZone): IColumn[] => [
  {
    title: 'Sec/Ind',
    name: 'sector',
    width: 71,
    maxWidth: 71,
    minWidth: 71,
    cellCallback: (cellProps) => <SectorIndustryCell { ...cellProps } />,
  },
  {
    name: 'headline',
    title: 'Headline',
    className: styles.headlineCell,
    cellCallback: (cellProps) => <HeadlineCell { ...cellProps } />,
  },
  {
    name: 'type',
    title: 'Type',
    width: 180,
    maxWidth: 180,
    className: alignStyles.alignRight,
    cellCallback: (cellProps) => <ArticleTypesCell { ...cellProps } />,
  },
  {
    name: 'region',
    title: 'region',
    width: 120,
    maxWidth: 120,
    cellCallback: (cellProps) => <MarketCell { ...cellProps } useEmDisplayNames />,
  },
  {
    name: 'publishedAt',
    title: 'date',
    width: 113,
    maxWidth: 113,
    className: cn(alignStyles.alignRight, textStyles.nowrap),
    cellCallback: ({ cellData }) => (
      cellData ? formatDateOrTime(cellData, timeZone, MONTH_DAY_YEAR_FORMAT, true) : EMPTY_CELL_STATE
    ),
  },
];

export default getEmergingMarketColumns;
